/**
 * A custom hook for retrieving product information.
 *
 * @returns {Object} An object containing the product information, error, and getProductInfo function.
 * @property {Object} productInfo - The product information.
 * @property {Object} error - The error object.
 * @property {Function} getProductInfo - A function for retrieving the product information.
 * @param {string} session_id - The session ID.
 * @param {string} vendor_url - The vendor URL.
 * @param {string} product_id - The product ID.
 * @param {string} timestamp - The timestamp.
 */

import { useState } from "react";
import { useSession } from "../utils/SessionContext";
import api from "../api/api";
import unixTimestamp from "../utils/unixTimestamp";

const useProductInfo = () => {
  const [productInfo, setProductInfo] = useState(null);
  const [error, setError] = useState(null);
  const { setShowModal } = useSession();
  const [loading, setLoading] = useState(false);

  const getProductInfo = async (session_id, vendor_url, product_id) => {
    const url = `/product_info`;
    try {
      setLoading(true);
      const res = await api.post(url, null, {
        params: {
          session_id,
          vendor_url,
          product_id,
          timestamp: unixTimestamp(),
        },
      });
      setProductInfo(res.data);
      setShowModal({ show: true, level: 2 });
    } catch (err) {
      setError(err.response.data);
    } finally {
      setLoading(false);
    }
  };

  const setAsSelectedProduct = (product) => {
    setProductInfo((prevState) => ({
      ...prevState,
      selected_product: product,
    }));
  };


  return { productInfo, error, getProductInfo, loading, setAsSelectedProduct };
};

export default useProductInfo;
